// Jetons de design partagés — un seul endroit à changer pour toucher tout le panel plutôt que
// des couleurs hex éparpillées par élément comme c'était le cas avant cette refonte.
export const colors = {
  bg: "#F6F7F9",
  card: "#FFFFFF",
  border: "#ECEEF1",
  borderStrong: "#E0E0E0",
  text: "#0B0B0F",
  textMuted: "#6B7280",
  textFaint: "#9AA0A8",
  accent: "#0000FF",
  accentSoft: "#EEF0FF",
  success: "#1D9E75",
  successSoft: "#E4F6EE",
  danger: "#C0392B",
  dangerSoft: "#FDEAEA",
  warning: "#B7791F",
  warningSoft: "#FDF3DD",
};

export const radius = { sm: 8, md: 12, lg: 16, pill: 999 };

export const shadow = "0 1px 2px rgba(16,24,40,0.04)";

export const font = {
  h1: { fontSize: 26, fontWeight: 800, letterSpacing: -0.3 },
  h2: { fontSize: 15, fontWeight: 700 },
  label: { fontSize: 11, fontWeight: 700, textTransform: "uppercase" as const, letterSpacing: 0.5 },
  body: { fontSize: 13.5 },
  sub: { fontSize: 12.5, color: colors.textMuted },
};
